import { Box } from "@chakra-ui/react"
import { useEffect, useRef } from "react"

type Props = {
  handleLoadMore: () => void
  triggerMargin?: number
}

const InfiniteScroll = ({ handleLoadMore, triggerMargin = 400 }: Props) => {
  // Add loader reference to be used for observation
  const loaderDivRef = useRef(null)

  useEffect(() => {
    // This is the options object needed to initialize IntersectionObserver
    const options = {
      root: null,
      rootMargin: `${triggerMargin}px`,
      threshold: 1.0,
    }

    // Initialize IntersectionObserver and attach it to loader div
    const observer = new IntersectionObserver(handleObserver, options)
    if (loaderDivRef.current) {
      observer.observe(loaderDivRef.current)
    }

    // Cleanup the observer
    return () => {
      observer.disconnect()
    }
  })

  // Here we handle what happens when user scrolls to loader div
  const handleObserver = ([entry]) => {
    if (entry.isIntersecting) {
      handleLoadMore()
    }
  }

  return <Box ref={loaderDivRef} w="100%" mx="auto" my="0" h="18" />
}

export default InfiniteScroll
